import React from 'react';
import { useNavigate } from 'react-router-dom';
import Icon from '../../../components/AppIcon';
import Button from '../../../components/ui/Button';
import { PLAN_SLUGS, getPlanConfig } from '../../../config/plans';

const SubscriptionBanner = ({ currentTier = PLAN_SLUGS.TRIAL, subscription = null, usageStats = null }) => {
  const navigate = useNavigate();

  const plan = getPlanConfig(currentTier);
  const isTrial = plan.slug === PLAN_SLUGS.TRIAL;
  const isAnalysis = plan.slug === PLAN_SLUGS.ANALYSIS;
  const isPro = plan.slug === PLAN_SLUGS.PRO;

  const getMessage = () => {
    if (isPro) return 'Accès complet : analyses illimitées, comparaison de scénarios, rapports et projections avancées.';
    if (isAnalysis) return 'Plan Analyse actif : analyses immobilières, sauvegarde, cashflow et ratios de rentabilité.';
    const used = usageStats?.analyses?.used ?? 0;
    const limit = usageStats?.analyses?.limit ?? plan.analysisLimit;
    return `Essai gratuit : ${used}/${limit} analyses utilisées. Passez à Analyse ou Pro pour continuer après la limite.`;
  };

  return (
    <div style={{
      background: (isPro || isAnalysis) ? 'rgba(59, 130, 246, 0.08)' : 'rgba(255,255,255,0.03)',
      borderRadius: 'var(--radius-lg)',
      padding: 'var(--spacing-md) var(--spacing-lg)',
      border: `1px solid ${(isPro || isAnalysis) ? 'var(--color-primary)' : 'var(--color-border)'}`,
      display: 'flex',
      alignItems: 'center',
      gap: 'var(--spacing-md)',
      flexWrap: 'wrap'
    }}>
      <div style={{
        width: '48px',
        height: '48px',
        borderRadius: 'var(--radius-md)',
        background: (isPro || isAnalysis) ? 'var(--color-primary)' : 'var(--color-muted-foreground)',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        flexShrink: 0
      }}>
        <Icon
          name={isPro ? 'Crown' : isAnalysis ? 'BarChart3' : 'Zap'}
          size={24}
          color="white"
        />
      </div>
      <div style={{ flex: 1, minWidth: '200px' }}>
        <div style={{
          display: 'flex',
          alignItems: 'center',
          gap: 'var(--spacing-xs)',
          marginBottom: '4px'
        }}>
          <h4 style={{
            fontFamily: 'var(--font-heading)',
            fontSize: '1rem',
            fontWeight: 600,
            color: 'var(--color-foreground)'
          }}>
            Plan {plan.name}
          </h4>
          {(isPro || isAnalysis) && (
            <span style={{
              padding: '2px 8px',
              borderRadius: 'var(--radius-sm)',
              background: 'var(--color-primary)',
              color: 'white',
              fontSize: '0.75rem',
              fontWeight: 600,
              fontFamily: 'var(--font-caption)'
            }}>
              {subscription?.status === 'trialing' ? 'ESSAI' : 'ACTIF'}
            </span>
          )}
        </div>
        <p style={{
          fontFamily: 'var(--font-body)',
          fontSize: '0.875rem',
          color: 'var(--color-muted-foreground)',
          lineHeight: 1.4
        }}>
          {getMessage()}
        </p>
        {subscription?.cancel_at_period_end && (
          <p style={{
            fontFamily: 'var(--font-body)',
            fontSize: '0.75rem',
            color: 'var(--color-warning)',
            marginTop: '4px',
            fontWeight: 500
          }}>
            <Icon name="AlertCircle" size={12} className="inline mr-1" />
            Annulation prevue le {new Date(subscription.current_period_end)?.toLocaleDateString('fr-CA')}
          </p>
        )}
      </div>
      {isTrial && (
        <Button
          variant="default"
          size="sm"
          iconName="Crown"
          iconPosition="left"
          onClick={() => navigate('/subscription-pricing')}
          data-testid="banner-upgrade-btn"
        >
          Voir les plans
        </Button>
      )}
      {(isPro || isAnalysis) && (
        <Button
          variant="outline"
          size="sm"
          iconName="Settings"
          iconPosition="left"
          onClick={() => navigate('/subscription-pricing')}
          data-testid="banner-manage-btn"
        >
          Gerer l'abonnement
        </Button>
      )}
    </div>
  );
};

export default SubscriptionBanner;
